/**
 * 配置测试工具
 * 在浏览器控制台中运行此函数来测试配置
 */

import { config, environment, allEnvironments } from '../config/environment';

export const testConfig = () => {
  console.log('🧪 环境配置测试');
  console.log('================================');
  
  console.log('📋 当前环境配置:');
  console.log('  环境名称:', config.name);
  console.log('  API地址:', config.apiBaseUrl);
  console.log('  服务器IP:', config.serverIp);
  console.log('  描述:', config.description);
  
  console.log('\n🌍 环境信息:');
  console.log('  当前环境:', environment.current);
  console.log('  是否开发环境:', environment.isDevelopment);
  console.log('  是否测试环境:', environment.isTest);
  console.log('  是否生产环境:', environment.isProduction);
  
  console.log('\n📋 所有环境配置:');
  Object.keys(allEnvironments).forEach(env => {
    const envConfig = allEnvironments[env];
    console.log(`  ${env}:`, {
      apiBaseUrl: envConfig.apiBaseUrl,
      serverIp: envConfig.serverIp,
      description: envConfig.description
    });
  });
  
  console.log('\n✅ 配置测试完成！');
  
  return {
    current: config,
    environment,
    all: allEnvironments
  };
};

// 在开发环境下自动运行测试
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 开发环境 - 自动运行配置测试');
  testConfig();
}

export default testConfig; 